// extracted by mini-css-extract-plugin
export default {"container":"perks_container","title":"perks_title","icon":"perks_icon","perksContainer":"perks_perksContainer","perkItem":"perks_perkItem","wordBreak":"perks_wordBreak"};